module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8beb9da10f72d02b48baf0b24ac72449.svg";